import React, { useContext } from 'react';
import { Row, Col, Container } from 'reactstrap';
import { SessionContext } from '../../context/SessionContext';
import styles from './BrandInformationMP.module.css';
import BrandedIcon from '../../components/BrandingWhiteLabel/BrandedIcon';

const BrandInformationMP = () => {
    const sessionContext = useContext(SessionContext);
    const { accountName } = sessionContext;

    const BrandServiceInfo = ({ iconType, title, text }) => {
        return (
            <Col
                xs='6'
                sm='6'
                md='4'
                lg='4'
                className={styles.brandContainer}
            >
                <div className='media'>
                    <span className={styles.brandIcon}>
                        <BrandedIcon
                            accountName={accountName}
                            iconType={iconType}
                        />
                    </span>
                    <div>
                        <h4>{title}</h4>
                        <p>{text}</p>
                    </div>
                </div>
            </Col>
        );
    };

    return (
        <Container
            fluid
            className={styles.contentContainer}
        >
            <Container>
                <Row>
                    <Col className='text-center'>
                        <h1 className={styles.brandHeading}>Grow Your Business with Labor Protection</h1>
                    </Col>
                </Row>
                <Row className={styles.brandInfoContainer}>
                    <BrandServiceInfo
                        iconType='profits'
                        title='Amplify Profit Potential'
                        text='Maximize revenue on every HVAC installation by adding an extended service agreement.'
                    />
                    <BrandServiceInfo
                        iconType='customers'
                        title='Build Customer Loyalty'
                        text='Create opportunities for yourself to build relationships that keep customers year after year.'
                    />
                    <BrandServiceInfo
                        iconType='online'
                        title='Easy Online Management'
                        text='Enter sales, manage agreements and track claims all in one place from our easy-to-use portal.'
                    />
                    <BrandServiceInfo
                        iconType='payment'
                        title='Fast Claims Payment'
                        text='Get reimbursed quickly with claim payments typically processed within two weeks.'
                    />
                    <BrandServiceInfo
                        iconType='coverage'
                        title='Flexible Coverage Options'
                        text="Offer various reimbursement and term options to best meet you and your customers' needs."
                    />
                    <BrandServiceInfo
                        iconType='servicerevenue'
                        title='Secure Service Revenue'
                        text='Transform every one-time installation into a long-term service income opportunity.'
                    />
                </Row>
            </Container>
        </Container>
    );
};

export default BrandInformationMP;
